// extracted by mini-css-extract-plugin
export var container = "_8q-0";
export var error = "_8q-9";
export var label = "_8q-5";
export var light = "_8q-6";
export var md = "_8q-3";
export var sm = "_8q-2";
export var thin = "_8q-8";
export var thinBold = "_8q-7";
export var vertical = "_8q-4";
export var xs = "_8q-1";